<template>
  <div class="ratio ratio-16x9">
    <iframe
      id="game"
      src="https://jobshark.eu/sharkman/index.html"
      title="Sharkman"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    email: String,
  },
  data: () => ({}),
  methods: {
    handleMessage(event) {
      let iFrame = document.getElementById('game');
      // Check if the message is from the expected iframe
      if (event.source === iFrame.contentWindow) {
        // Handle the message data
        const message = JSON.parse(event.data);
        console.log('MEssage from Petko', event.data);
        if (message.option === 'gameOver') {
          this.$emit('scores');
        } else if (message.option === 'server') {
          this.register();
          this.$emit('loaded');
        }
      }
    },
    register() {
      let iFrame = document.getElementById('game');
      iFrame.contentWindow.messageToUnity(
        JSON.stringify({
          domain: 'https://jobshark.eu',
          email: this.email,
          name: this.name,
        }),
      );
    },
  },
  mounted() {
    window.addEventListener('message', this.handleMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage);
  },
};
</script>

<style lang="scss" scoped>
.shark {
  background-color: #1c1e21;
  height: 100vh;
  overflow-x: hidden;
  .d-flex {
    height: 100vh;
    align-items: center;
  }
  .game-container {
    width: 80%;
    height: 100vh;
    background: #000;
    display: flex;
    align-items: center;
  }
  .scores {
    flex: 1;
    align-self: flex-start;
    .header {
      background: #242526;
      color: #fff;
      padding: 12px;
      text-transform: uppercase;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      margin-bottom: 12px;
      h2 {
        font-weight: 700;
        margin-bottom: 0;
        font-size: 18px;
      }
    }
    .list-unstyled {
      li {
        align-items: center;
        display: flex;
        color: #fff;
        border-bottom: 1px dotted rgba(255, 255, 255, 0.4);
        padding: 6px 12px;
      }
    }
  }
  .overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    .modal-game {
      padding: 50px;
      width: 540px;
      background-color: #1c1e21;
      border-radius: 12px;
      .form-group {
        .form-control {
          background: #242526;
          border-radius: 22px;
          padding: 28px 12px;
        }
        .btn-primary {
          border-radius: 22px;
          width: 72%;
          display: block;
          margin: 0 auto;
          padding: 15px 12px;
          font-weight: 700;
          font-size: 18px;
          background: rgba(0, 0, 0, 0.4);
          color: #ffff33;
          border: none;
        }
        &.error {
          background: red;
          padding: 8px 22px;
          font-size: 14px;
          border-radius: 12px;
          p {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
